var option_webview_default = {
  "option": "lHNgO",
  "user_choice": "geqxm",
  "check": "M9AEE",
  "image": "-PuM6",
  "input": "d-CqG",
  "title": "rnW-m",
  "centered": "peZiz",
  "with_result": "B9Pu8",
  "list": "JapmV",
  "with_image": "mWHzQ",
  "progress": "qP5M5",
  "progress_value": "jxLpP",
  "label": "BvXFi",
  "cta": "_3uq2m",
  "adornment_icon": "-ch2K",
  "remove": "tU9H4",
  "removeButton": "uk-H4",
  "removeButtonIcon": "eCTAl",
  "overlay": "vshGh",
  "shown": "_9Bqsx",
  "dark": "D8G27",
  "spinner": "sMEiQ",
  "spin": "A8Oer",
  "grid": "D79Tn"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
